export { default as diService } from "./application/di.service";
export { IDi, type IDiDecorator } from "./domain/Di";
